<div class="empty-state-wrap">
  <div class="empty-state-card">

    <div class="empty-state-icon">
      <img class="empty-state-img" src="/assets/e-commerce/icons/47.webp" alt="empty orders" />
    </div>

    <h2 class="empty-state-title">
      {{ "No orders" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "You have no orders yet, start shopping now" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/Home">
      {{ "shopping" | transloco }}
    </button>
  </div>
</div>